
import "@sparta.global.utilities/css-selector-parser-utility/dist/styles.css"
import "@sparta.auto-loans.modules/three-column-module/dist/styles.css"
import "@sparta.auto-loans.modules/single-column-centered-content-module/dist/styles.css"
import "@sparta.auto-loans.modules/learning-center-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import ampTriggerVideoUtility from "@sparta.global.utilities/amp-trigger-video-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import timeBoxUtility from "@sparta.sales.utilities/time-box-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"

import "@sparta.auto-loans.modules/three-column-module/dist/es6.js"
import "@sparta.auto-loans.modules/single-column-centered-content-module/dist/es6.js"
import "@sparta.auto-loans.modules/single-column-centered-content-module/dist/es6.js"
import "@sparta.auto-loans.modules/learning-center-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}


// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  secureLinkUtility.run()
timeBoxUtility.run()
await spartaBootstrapUtility.init(arguments);
spartaRegisterSwUtility.init();
  console.log('after - execute boot functions')
})();
